module.exports = __webpack_public_path__ + "static/img/01014A_2_3_R_20181212_LC.3ced75c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01014A_2_3_R_20181212_LC.png
// module id = Ck+g
// module chunks = 0